import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MedicationsPage } from './medications';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    MedicationsPage,
  ],
  imports: [
    IonicPageModule.forChild(MedicationsPage),
    DirectivesModule
  ],
})
export class MedicationsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/medications/medications.module.ts